import { render, staticRenderFns } from "./EiBackHeadInfo.vue?vue&type=template&id=1b819f66&scoped=true&"
import script from "./EiBackHeadInfo.vue?vue&type=script&lang=js&"
export * from "./EiBackHeadInfo.vue?vue&type=script&lang=js&"
import style0 from "./EiBackHeadInfo.vue?vue&type=style&index=0&id=1b819f66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b819f66",
  null
  
)

export default component.exports